import { Injectable} from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SessionService } from "./session.service";

@Injectable()
export class ApiService {
  private protoCol: string = (location && location.protocol && ['http:', 'https:'].includes(location.protocol)) ? location.protocol : 'https:';
  private countryPromise: Promise<any>;
  constructor(private http: HttpClient, private sessionService: SessionService) {
  }

  post(data) {
    let url = '';
    if(environment.production){
      url = `${this.protoCol}//${globalThis.location.hostname}/api/${data.url}`;
    }else{  
      url = environment.API_ENDPOINT + data.url;
    }

    data.body['domain_name'] = data.body['domain_name'] || this.sessionService.getString('domain');
    if (this.sessionService.get('config') && this.sessionService.get('config').is_dual_user_enable === 1) {
      data.body['dual_user_key'] = 1;
    } else {
      data.body['dual_user_key'] = 0;
    }

    if (!('language' in data.body)) {
      data.body['language'] = this.sessionService.getString('language') || 'en';
    }

    return this.http
      .post(url, data.body,{ headers : this.setCustomizeHeaders()})
      .pipe(map(this.tookanResponse));

  }

  post_test(data) {
    let url = '';
    if(environment.production){
      url = `${this.protoCol}//${globalThis.location.hostname}/api/${data.url}`;
    }else{  
      url = environment.API_ENDPOINT + data.url;
    }

    data.body['domain_name'] = data.body['domain_name'] || this.sessionService.getString('domain'); 

    if (!('language' in data.body)) {
      data.body['language'] = this.sessionService.getString('language') || 'en'; 
    }
    data.body.marketplace_user_id = this.sessionService.get('config').marketplace_user_id;
    return this.http
      .post(url, data.body,{ headers :  this.setCustomizeHeaders() })
      .pipe(map(this.tookanResponse));

  }

  put(data) {
    let url = '';
    if(environment.production){
      url = `${this.protoCol}//${globalThis.location.hostname}/api/${data.url}`;
    }else{  
      url = environment.API_ENDPOINT + data.url;
    }

    data.body['domain_name'] = data.body['domain_name'] || this.sessionService.getString('domain');

    if (this.sessionService.get('config') && this.sessionService.get('config').is_dual_user_enable === 1) {
      data.body['dual_user_key'] = 1;
    } else {
      data.body['dual_user_key'] = 0;
    }


    if (!('language' in data.body)) {
      data.body['language'] = this.sessionService.getString('language') || 'en'; 
    }


    return this.http
      .put(url, data.body,{ headers :  this.setCustomizeHeaders() })
      .pipe(map(this.tookanResponse));

  }

  postWithoutDOmain(data) {
    let url = '';
    if(environment.production){
      url = `${this.protoCol}//${globalThis.location.hostname}/api/${data.url}`;
    }else{  
      url = environment.API_ENDPOINT + data.url;
    }

    return this.http
      .post(url, data.body,{ headers :  this.setCustomizeHeaders() })
      .pipe(map(this.tookanResponse));

  }

  get(data) {
    let url = '';
    if(environment.production){
      url = `${this.protoCol}//${globalThis.location.hostname}/api/${data.url}`;
    }else{  
      url = environment.API_ENDPOINT + data.url;
    }

    const params = this.mapDataToUrl(data);
    url += '?' + params;
    return this.http
      .get(url,{headers: this.setCustomizeHeaders()})
      .pipe(map(this.tookanResponse));

  }

  getWithoutPostToGet(data) {
    let url = '';
    if(environment.production){
      url = `${this.protoCol}//${globalThis.location.hostname}/api/${data.url}`;
    }else{  
      url = environment.API_ENDPOINT + data.url;
    }

    const params = this.mapDataToUrlWithoutPostToGet(data);
    url += '?' + params;
    return this.http
      .get(url,{ headers :  this.setCustomizeHeaders() })
      .pipe(map(this.tookanResponse));

  }

  private mapDataToUrlWithoutPostToGet(data: any) {
    data.body['domain_name'] = this.sessionService.getString('domain'); 
    if (this.sessionService.get('config') && this.sessionService.get('config').is_dual_user_enable === 1) {
      data.body['dual_user_key'] = 1;
    }
    else {
      data.body['dual_user_key'] = 0;
    }
    if (!('language' in data.body)) {
      data.body['language'] = this.sessionService.getString('language') || 'en';
    }
    let params = [];
    Object.keys(data.body).forEach(key => {
      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(data.body[key])}`);
    })
    return params.join('&');
  }

  private mapDataToUrl(data: any) {
    const config = this.sessionService.get('config') || {};
    let obj = {
      domain_name: config.domain_name || this.sessionService.getString('domain'),

      post_to_get: 1,
      ...data.body
	}

	if(!data.body.noDualUser){
    const language = globalThis.location.pathname.split('/')[1]
		obj = {
			...obj,
			dual_user_key: config.is_dual_user_enable === 1 ? 1 : 0,
            language: 
            data.body['language'] || 
            language || 
            this.sessionService.getString('language') || 
            'en'
		}
	}
	else{
		delete obj.noDualUser;
	}

    let params = [];
    Object.keys(obj).forEach(key => {
      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    })
    return params.join('&');
  }


  getCountryData(data) {
    let url = '';
    url = environment.API_ENDPOINT_TOOKAN + data.url;
    if (!this.countryPromise) {
      this.countryPromise = this.http
        .get(url)
        .pipe(map((res: any) => {
          // sessionStorage.setItem('country_config', JSON.stringify(res));
          return res;
        })).toPromise();
    }
    return new Observable((observer) => {
      this.countryPromise.then(res => {
        observer.next(res);
        observer.complete();
      }).catch(err => observer.error(err))
      return () => observer.unsubscribe();
    });

  }

  getCountryInfo() {
    let url = 'requestCountryCodeGeoIP2';
    url = environment.API_ENDPOINT_TOOKAN + url;
    if (!this.countryPromise) {
      this.countryPromise = this.http
        .get(url)
        .pipe(map((res: any) => {
          return res;
        })).toPromise();
    }
    return new Observable((observer) => {
      this.countryPromise.then(res => {
        observer.next(res);
        observer.complete();
      }).catch(err => observer.error(err))
      return () => observer.unsubscribe();
    });
  }

  getWithEncodedParams(api_url, params) {
    let url = '';
    if(environment.production){
      url = `${this.protoCol}//${globalThis.location.hostname}/api/${api_url}`;
    }else{  
      url = environment.API_ENDPOINT + api_url;
    }

    return this.http
      .get(url, { params,headers :  this.setCustomizeHeaders()})
      .pipe(map(this.tookanResponse));
  }

  /** Tookan not following response code standards. */
  tookanResponse(res: any) {
    return res;
  }

  setCustomizeHeaders()
  {
    const headers = new HttpHeaders().set('base_version', '1.0.0').set('device_type', 'WEB');
    return headers;
  }
  

  getActiveMenuList(data) {
  let url = '';
  if(environment.production){
    url = `${this.protoCol}//${globalThis.location.hostname}/api/${data.url}`;
  }else{  
    url = environment.API_ENDPOINT + data.url;
  }
  return this.http
    .post(url, data.body,{ headers : this.setCustomizeHeaders()})
    .pipe(map(this.tookanResponse));
  }

  tata_api_url(data, headers:any, route: string) {
  let baseUrl = environment.TATA_ENDPOINT
  let url = route ? `${baseUrl}/${route}` : baseUrl;
  return this.http
    .post(url, data, { headers })
    .pipe(map(this.tookanResponse));
  }

  authenticateTataLogin(data) {
  let url = '';
  if(environment.production){
    url = `${this.protoCol}//${globalThis.location.hostname}/api/${data.url}`;
  }else{  
    url = environment.API_ENDPOINT + data.url;
  }

  return this.http
    .post(url, data.body,{ headers : this.setCustomizeHeaders()})
    .pipe(map(this.tookanResponse));
  }

}
